// extracted by mini-css-extract-plugin
export default {"gradientText":"OwnersPage_gradientText__BlmWN"};